export default __webpack_public_path__ + "static/LandBlock-ff0bc1cd6d868317a51702dced414b74.png";